import {
    ADD_UNIT_UTILITY, ADD_UTILITIES_BULK, BULK_CREATE_UTILITY_INVOICES,
    DELETE_UNIT_UTILITY, FETCH_PROPERTY_UTILITIES, FETCH_UNIT_UTILITIES,
    RESET_UTILITIES,
    UPDATE_UNIT_UTILITY
} from "./actionTypes";
import { formatDateQueryInput } from '../../utils/general';


const fetchUnitUtilities = ({propertyIds, unitIds,
    startDate, endDate, utilityItems, offset, appendData}) => {
        startDate = formatDateQueryInput(startDate);
        endDate = formatDateQueryInput(endDate, false);
        return ({
            type: FETCH_UNIT_UTILITIES,
            payload: {
                propertyIds,
                unitIds,
                startDate,
                endDate,
                utilityItems,
                offset,
                appendData
            }
        });
}

const fetchPropertyUnitUtilities = ({propertyIds, unitIds, utilityItem}) => {
        return ({
            type: FETCH_PROPERTY_UTILITIES,
            payload: {
                propertyIds,
                unitIds,
                utilityItem
            }
        });
}

const addUtilitiesBulk = (payload) => ({
    type: ADD_UTILITIES_BULK,
    payload,
    errors: null
})



const addUnitUtility = ({ unitId, date, item, currentReading, previousReading, invoiceId }) => ({
    type: ADD_UNIT_UTILITY,
    payload: {
        unitId,
        date,
        item,
        currentReading,
        previousReading,
        invoiceId
    },
    errors: null
})

const updateUnitUtility = ({ utilityId, unitId, date, item, currentReading, previousReading, invoiceId }) => ({
    type: UPDATE_UNIT_UTILITY,
    payload: {
        utilityId,
        unitId,
        date,
        item,
        currentReading,
        previousReading,
        invoiceId
    },
    errors: null
})

const deleteUnitUtility = (utilityId) => ({
    type: DELETE_UNIT_UTILITY,
    payload: {
        utilityId,
    },
    errors: null
})

const bulkCreateUtilityInvoices = (utilityIds) => ({
    type: BULK_CREATE_UTILITY_INVOICES,
    payload: {utilityIds},
    errors: null
})

const resetUtilities = (payload) => ({
    type: RESET_UTILITIES,
    payload,
    message: "",
    errors: null
})

export {
    addUnitUtility, updateUnitUtility, deleteUnitUtility,
    fetchUnitUtilities, fetchPropertyUnitUtilities,
    addUtilitiesBulk, bulkCreateUtilityInvoices, resetUtilities
}